import axios from "axios";
import Config from "@/Configuration/Config";

export default {
    allUrl: Config.apiBaseUrl + "api/Pixel/All",
    getUrl: Config.apiBaseUrl + "api/Pixel/Get?pixelId=",
    addOrUpdateUrl: Config.apiBaseUrl + "api/Pixel/AddOrUpdate",
    removeUrl: Config.apiBaseUrl + "api/Pixel/Remove",

    getAll(filter) {
        return axios.post(this.allUrl, filter)
    },
    addOrUpdate(pixel) {
        return axios.post(this.addOrUpdateUrl, pixel)
    },
    getById(id) {
        return axios.get(this.getUrl     + id);
    },
    remove(id) {
        const fd = new FormData();
        fd.append("pixelId", id);
        return axios({
            method: "post",
            url: this.removeUrl,
            data: fd,
            headers: {
                "Content-Type": "multipart/form-data",
                Accept: "application/json",
            },
        });
    }
}